const columns = [
  { title: 'Vehicle Id', dataIndex: 'vehicleId', key: 'vehicleId' },
  { title: 'Entry Time', dataIndex: 'entryTime', key: 'entryTime' },
  { title: 'Exit Time', dataIndex: 'exitTime', key: 'exitTime' },
  { title: 'Parking Lot', dataIndex: 'parkingLot', key: 'parkingLot' },
];

export default columns;